// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { SlTpPriceType } from '../../Utils/Enums/Constants';
import { Message } from './Message';
import { ProductType } from '../Instruments/ProductType';
import { OperationType } from '../Trading/OperationType';
export class DirectOpenOrderMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_OPENORDER);
        // значение sl в цене или тиках в зависимости от SlPriceType
        this.StopLossPriceValue = NaN;
        // значение tp в цене или тиках в зависимости от TPPriceType
        this.TakeProfitPriceValue = NaN;
        this.StopLossPriceType = SlTpPriceType.Absolute;
        this.TakeProfitPriceType = SlTpPriceType.Absolute;
        this.OrderWasManual = null;
        this.Account = null;
        this.BuySell = OperationType.Buy;
        this.OrderNumber = null;
        this.OrderType = 0;
        this.Price = 0;
        this.LastPrice = null;
        this.Quantity = 0;
        this.LastAmount = null;
        this.RemoteID = null;
        this.ErrorCode = null;
        this.Replaceable = false;
        this.AutoTradeOrder = false;
        this.Route = null;
        this.SharesFilled = 0;
        this.AverageFilledPrice = 0;
        this.StopLimit = 0;
        this.Symbol = null;
        // Под нефикс список, для прочих - бери Symbol и не парься
        this.InstrumentID = 0;
        this.UTCDateTime = null;
        this.TimeInForce = 0;
        this.Token = '-1';
        this.ExecutionType = null;
        this.OrderStatus = null;
        this.PositionId = '-1';
        // для GTD
        this.ExpireTime = null;
        this.ProductType = ProductType.General;
        this.boundToOrderId = '-1';
        this.IsActivated = false; // #92963
        this.active = false;
        // признак что ордер открывающий
        this.IsOpen = false;
        // #34674
        this.realactive = false;
        this.OrderGroupId = 0;
        this.Exchange = null;
        this.InitMargin = 0;
        this.Roundtrip = 0;
        this.TriggerSL = null; // #109798
        this.TriggerTP = null;
        this.TriggerSLTP = null;
        this.TradingSignalId = 0;
        // Управление разрешением SLTP на уровне отдельного ордера
        // заводили под интеграции, нашим сервером пока не используется
        this.SLTPAllowed = true;
        // Все параметры ордера
        this.AdvancedOrderTypeParameters = null;
        this.InstrumentTradableID = null;
        // TODO. Refactor? Remove?
        this.stopLossLimit = 0; // #91413
        this.takeProfitLimit = 0;
        this.disClosedQuantity = null;
        this.comment = null;
        this.userComment = null;
        this.strategyId = null;
        this.lackOfMargin = null; // #94155
        this.FMasterID = null;
        this.FOrderCreatedByUser = null;
        this.FLastUpdateTime = null;
        this.trStopOffset = 0;
        this.externalOrderId = null;
        this.externalStatus = 0;
        // Панель с которой был отправлен Ордер
        this.FClientPanelId = 0;
        this.IsAllowOTHTrading = null;
    }
    // TODO. Refactor? Remove?
    get StopLossLimit() {
        return this.stopLossLimit;
    }
    set StopLossLimit(val) {
        this.stopLossLimit = val;
    }
    // TODO. Refactor? Remove?
    get TakeProfitLimit() {
        return this.takeProfitLimit;
    }
    set TakeProfitLimit(val) {
        this.takeProfitLimit = val;
    }
    get Comment() {
        return this.comment;
    }
    set Comment(val) {
        this.comment = val;
    }
    get UserComment() {
        return this.userComment;
    }
    set UserComment(val) {
        this.userComment = val;
    }
    get StrategyId() {
        return this.strategyId;
    }
    set StrategyId(val) {
        this.strategyId = val;
    }
    // #94155
    get LackOfMargin() {
        return this.lackOfMargin;
    }
    set LackOfMargin(val) {
        this.lackOfMargin = val;
    }
    get BoundToOrderId() {
        return this.boundToOrderId;
    }
    set BoundToOrderId(val) {
        this.boundToOrderId = val;
    }
    get Active() {
        return this.active;
    }
    set Active(val) {
        this.active = val;
    }
    // #34674
    get RealActive() {
        return this.realactive;
    }
    set RealActive(val) {
        this.realactive = val;
    }
    get MasterID() {
        return this.FMasterID;
    }
    set MasterID(val) {
        this.FMasterID = val;
    }
    get OrderCreatedByUser() {
        return this.FOrderCreatedByUser;
    }
    set OrderCreatedByUser(val) {
        this.FOrderCreatedByUser = val;
    }
    get LastUpdateTime() {
        return this.FLastUpdateTime;
    }
    set LastUpdateTime(val) {
        this.FLastUpdateTime = val;
    }
    // Офсет (только для трейлинг стопа)
    get TrStopOffset() {
        return this.trStopOffset;
    }
    set TrStopOffset(val) {
        this.trStopOffset = val;
    }
    get ExternalOrderId() {
        return this.externalOrderId;
    }
    set ExternalOrderId(val) {
        this.externalOrderId = val;
    }
    get ExternalStatus() {
        return this.externalStatus;
    }
    set ExternalStatus(val) {
        this.externalStatus = val;
    }
    // Панель с которой был отправлен Ордер
    get ClientPanelId() {
        return this.FClientPanelId;
    }
    set ClientPanelId(val) {
        this.FClientPanelId = val;
    }
    get DisClosedQuantity() {
        return this.disClosedQuantity;
    }
    set DisClosedQuantity(val) {
        this.disClosedQuantity = val;
    }
}
